import React from 'react';

import selectFiles from '@chenyuwang/select-files';
import { Button, ButtonProps } from '@components/Button';
import { InputCommonProps } from '@components/NextForms/common';
import { ErrorMessages } from '@components/NextForms/ErrorMessages';
import { FileItem } from '@components/utilities/BookingInquiry/FileArrayDisplay';
import { LocalFile, OptionalLocalFile } from '@models/next/FileType';
import { empty, mapDecodeResult, MobxZodField } from '@monoid-dev/mobx-zod-form';
import { makeMuiStyles } from '@styles';
import { formStrings } from '@utils/forms';
import { observer } from 'mobx-react';
import { ZodTypeAny } from 'zod';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeMuiStyles((theme, common) => ({}));

export type FileInputProps = InputCommonProps & {
  variant?: 'button';
  field: MobxZodField<typeof OptionalLocalFile> | MobxZodField<typeof LocalFile>;
  accept?: string;
  hideButtonIfHasFile?: boolean;
  buttonProps?: Partial<ButtonProps>;
};

export const FileInput: React.FC<FileInputProps> = observer(
  ({
    field,
    accept = field.type.description,
    readOnly = false,
    withErrorMessages = true,
    hideButtonIfHasFile = false,
    buttonProps,
  }) => {
    const showButton =
      readOnly || !hideButtonIfHasFile || !(field.decodeResult.success && field.decodeResult.data);

    return (
      <>
        {mapDecodeResult(
          field.decodeResult,
          (d) =>
            d && (
              <FileItem
                index={1}
                file={d as any}
                onDelete={() => field.setOutput(empty)}
                readOnly={readOnly}
              />
            ),
          null,
        )}

        {showButton && (
          <Button
            text={buttonProps?.text ?? formStrings.upload}
            color="primary"
            size="small"
            type="button"
            onClick={async () => {
              const [file] = [...((await selectFiles({ accept, multiple: false })) ?? [])];

              if (!file) return;

              field.setOutput({
                file,
              });

              field.setTouched(true);
            }}
            disabled={readOnly}
            {...buttonProps}
          />
        )}

        {/** TS complains when not casted to ZodTypeAny */}
        {withErrorMessages && <ErrorMessages field={field as MobxZodField<ZodTypeAny>} />}
      </>
    );
  },
);
